import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { mediaApi } from "./api";
import type { MediaFilters, UpdateMediaInput } from "./types";

export const mediaKeys = {
  all: ["media"] as const,
  list: (filters: MediaFilters) => ["media", "list", filters] as const,
};

export function useMedia(filters: MediaFilters) {
  return useQuery({
    queryKey: mediaKeys.list(filters),
    queryFn: () => mediaApi.list(filters),
  });
}

export function useUploadMedia() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: mediaApi.upload,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: mediaKeys.all }),
  });
}

export function useUpdateMedia() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateMediaInput }) => mediaApi.update(id, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: mediaKeys.all }),
  });
}

export function useDeleteMedia() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: mediaApi.delete,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: mediaKeys.all }),
  });
}
